import React, { useEffect, useRef, useState } from "react";
import { Box, Container, IconButton, Popper, Stack, useMediaQuery } from "@mui/material";
import { LogoIcon } from "assets/icons";
import { desktop, mobile, tablet } from "utils";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { Nav } from "./Nav";

export const Header = () => {
  const matchesMobile = useMediaQuery(mobile);
  const matchesTablet = useMediaQuery(tablet);
  const matchesDesktop = useMediaQuery(desktop);
  const anchorRef = useRef(null);

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    if (matchesTablet || matchesDesktop) {
      setMobileMenuOpen(false);
    }
  }, [matchesTablet, matchesDesktop]);

  return (
    <Box
      ref={anchorRef}
      sx={{
        background: (theme) => (matchesDesktop ? theme.palette.background2.main : theme.palette.primary.main),
      }}
    >
      <Container maxWidth="xl">
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          py={matchesMobile ? "1rem" : "1.5rem"}
        >
          <Box onClick={() => window.scrollTo(0, 0)}>
            <LogoIcon
              color={matchesDesktop ? "#FF5F00" : "#fff"}
              width={matchesTablet ? 200 : matchesTablet && matchesMobile ? 151 : 295}
            />
          </Box>

          {matchesTablet ? (
            <IconButton color="primary" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
              <CloseIcon
                sx={{
                  display: mobileMenuOpen ? "block" : "none",
                }}
              />
              <MenuIcon
                sx={{
                  display: !mobileMenuOpen ? "block" : "none",
                }}
              />
            </IconButton>
          ) : (
            <Nav />
          )}
        </Stack>
      </Container>

      <Popper
        open={mobileMenuOpen}
        onClose={() => setMobileMenuOpen(!mobileMenuOpen)}
        anchorEl={anchorRef.current}
        disablePortal
        sx={{
          width: "100%",
          boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
          padding: "2rem 0",
          zIndex: 2,
          background: (theme) => theme.palette.background2.main,
          textAlign: "center",
        }}
      >
        <Nav setMobileMenuOpen={setMobileMenuOpen} />
      </Popper>
    </Box>
  );
};
